import "rc-slider/assets/index.css";
import "./../Styles/Designes.css";
import { API } from "./../../config/api";

import "aos/dist/aos.css";

export default function SellDesigns({
  designs,
  concepts,
  downloaded,
  cartIds,
  wishlistIds,
  triggerDownload,
  handleCardClick,
  addToCart,
  addToWishlist,
  loading,
}) {
  return (
    <div className="designs-grid">
      {loading ? (
        <div className="design-loading">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>

          <p>Loading paid designs...</p>
        </div>
      ) : designs.length > 0 ? (
        designs.map((design, index) => (
          <div
            className="design-card"
            key={design.id}
            data-aos="zoom-in-up"
            data-aos-delay={(index % 8) * 70}
            onClick={() => handleCardClick(design)}
          >
            <div className="image-wrapper">
              <img
                src={`${API.BASE_URL}/uploads/Design_seller/${design.user_id}/${design.jpeg_file}`}
                alt={design.design_code}
              />
            </div>
            <div className="card-body">
              <div className="design-specs">
                <div className="spec-left">
                  <div>
                    <strong className="strong1">Code:</strong>{" "}
                    {design.design_code}
                  </div>
                  <div>
                    <strong className="strong1">Stitch:</strong> {design.stitch}
                  </div>
                </div>
                <div className="spec-right text-start">
                  <div>
                    <strong className="strong1">Area:</strong> {design.area}
                  </div>
                  <div>
                    <strong className="strong1">Color:</strong> {design.color}
                  </div>

                  {/* <div><strong>Detail:</strong> {design.details}</div> */}
                </div>
              </div>
              {/* <div className="design-specs">
                <div>
                  <strong className="strong1">Concept:</strong>{" "}
                  {design.concepts_array
                    ?.map((id) => {
                      const concept = concepts.find((c) => c.id == id);
                      return concept ? concept.concept_name : null;
                    })
                    .filter(Boolean)
                    .join(", ")}
                </div>
              </div> */}

              <h5 className="price-tag-row text-center mt-2">
                ₹ {design.price}
              </h5>
              <div className="card-action-row">
                <div className="action-btns">
                  <button
                    className={`select-btn ${cartIds.includes(design.id) ? "selected-btn" : ""}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      addToCart(design);
                    }}
                  >
                    <i
                      className={`bi ${cartIds.includes(design.id) ? "bi-cart-check-fill" : "bi-cart-fill"} me-1`}
                    ></i>
                    {cartIds.includes(design.id) ? "SELECTED" : "SELECT"}
                  </button>
                  <button
                    className="wish-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      addToWishlist(design);
                    }}
                  >
                    <i
                      className={`bi ${wishlistIds.includes(design.id) ? "bi-heart-fill text-danger" : "bi-heart"}`}
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center py-5">
          <h4>No designs found.</h4>
        </div>
      )}
    </div>
  );
}
